export default "__VITE_ASSET__Deg_dvZc__"